import React, { useEffect, useState } from "react";
import Header from "./Header";
import "../../css/bootstrap.css";
import "../../css/common.css";
import "../../css/modal.css";
import Footer from "./Footer";
import favicon from "../../images/favicon.png";
import Helmet from "react-helmet";
import { getStructuredData, getOpenGraphTags, getTwitterCardTags, getAllMetaTags } from "../../utils/seo";
import { useSEO } from "../../hooks/useSEO";
// import "../../utils/seoTest"; // Import SEO test utility (disabled for production)

function Layout({ children, chatCodeId, from = "", seoData = null }) {
  const [windowObject, setWindowObject] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setWindowObject(window);
    }
  }, []);

  // useEffect(() => {
  //   if (!document.getElementById("lp_cwc_xqzyihjdskw")) {
  //     let chatDiv = document.getElementById("livprop_chatbox");
  //     if (chatDiv) {
  //       document.body.removeChild(chatDiv);
  //       if (
  //         chatDiv.nextElementSibling &&
  //         chatDiv.nextElementSibling.tagName === "script"
  //       ) {
  //         document.body.removeChild(chatDiv.nextElementSibling);
  //       }
  //     }
  //     const s1 = document.createElement("script");
  //     s1.id = "lp_cwc_xqzyihjdskw";
  //     s1.src = `https://cwc.livserv.in/chat.js?lid=${
  //       chatCodeId ? chatCodeId : 12981
  //     }`;
  //     const s2 = document.createElement("script");
  //     s2.id = "chatScript2";
  //     s2.src = `https://cw1.livserv.in?did=${
  //       chatCodeId ? chatCodeId : 12981
  //     }&pid=1`;
  //     document.body.appendChild(s1);
  //     document.body.appendChild(s2);

  //     return () => {
  //       document.body.removeChild(s1);
  //       document.body.removeChild(s2);
  //     };
  //   }
  // }, [chatCodeId]);

  // useEffect(() => {
  //   const whatsappbutton = document.querySelector('#whatsappbutton')
  //   const mobilelivesquare = document.querySelector('.mobilelivesquare')

  //   if(whatsappbutton && mobilelivesquare){
  //     console.log(windowObject?.location?.pathname.includes("promenade"))
  //     if(!windowObject?.location?.pathname.includes("promenade")) {
  //     whatsappbutton.style.display = 'block'
  //     mobilelivesquare.style.display = 'block'
  //     }
  //    else {
  //     whatsappbutton.style.display = 'none'
  //     mobilelivesquare.style.display = 'none'
  //   }
  // }
  // },[windowObject?.location?.pathname])

  // Get SEO data - use provided seoData or get from pathname using custom hook
  const dynamicSEOData = useSEO();
  const currentSEOData = seoData || dynamicSEOData;
  
  // Ensure we always have valid SEO data, especially during SSR
  const safeSEOData = currentSEOData || {
    metaTitle: 'Baashyaam Group - Luxury Apartments in Chennai',
    metaDescription: 'Discover luxury living in Chennai with Baashyaam Group. Premium residential and commercial projects with innovative architecture and unmatched lifestyle experience.',
    url: 'https://www.bashyamgroup.com/',
    canonical: 'https://bashyamgroup.com/'
  };

  const schemaJson = [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Baashyaam Constructions",
      "image": "https://www.bashyamgroup.com/static/d1005d88bee065ee771305d4da6d9226/44098/baashyaam_logo.png",
      "@id": "https://www.bashyamgroup.com/",
      "url": "https://www.bashyamgroup.com/",
      "telephone": "+91 9840477777",
      "priceRange": "$$$",
      "description": "Baashyaam Constructions is a leading real estate developer in Chennai, specializing in luxury apartments and residential projects.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "4th Floor, No.87 G.N. Chetty Road, T.Nagar",
        "addressLocality": "Chennai",
        "postalCode": "600017",
        "addressRegion": "Tamil Nadu",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 13.0456719,
        "longitude": 80.2415723
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "09:30",
        "closes": "18:00"
      },
      "sameAs": [
        "https://www.facebook.com/BaashyaamConstructions",
        "https://x.com/BaashyaamGroup",
        "https://www.instagram.com/baashyaam_constructions/",
        "https://www.youtube.com/@baashyaamconstructions154",
        "https://www.linkedin.com/company/baashyaam-constructions",
        "https://in.pinterest.com/baashyaamconstructions/"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.5",
        "reviewCount": "125"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Baashyaam Constructions",
      "alternateName": "Bashyamgroup",
      "url": "https://www.bashyamgroup.com/",
      "logo": "https://www.bashyamgroup.com/static/d1005d88bee065ee771305d4da6d9226/44098/baashyaam_logo.png",
      "sameAs": [
        "https://www.facebook.com/BaashyaamConstructions",
        "https://x.com/BaashyaamGroup",
        "https://www.instagram.com/baashyaam_constructions/",
        "https://www.youtube.com/@baashyaamconstructions154",
        "https://www.linkedin.com/company/baashyaam-constructions",
        "https://in.pinterest.com/baashyaamconstructions/"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What makes Baashyaam luxury apartments different from regular apartments?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Baashyaam apartments focus on premium locations, modern architecture, high-end finishes, and world-class amenities for a better lifestyle."
          }
        },
        {
          "@type": "Question",
          "name": "Where are Baashyaam luxury apartments located in Chennai?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "They are located in prime areas like Poes Garden, LB Road, West Mambalam, and other well-connected neighborhoods across Chennai."
          }
        },
        {
          "@type": "Question",
          "name": "Are luxury apartments in Chennai a good investment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Luxury apartments in Chennai offer high resale value, strong rental demand, and long-term appreciation due to prime locations."
          }
        },
        {
          "@type": "Question",
          "name": "What amenities do Baashyaam luxury apartments offer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "They include swimming pools, gyms, landscaped gardens, clubhouses, security, and smart home features designed for comfort."
          }
        },
        {
          "@type": "Question",
          "name": "What is the price range of Baashyaam luxury apartments in Chennai?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prices vary by location and size, starting from mid-range premium apartments to ultra-luxury residences in prime neighborhoods."
          }
        },
        {
          "@type": "Question",
          "name": "Can I get a home loan for a Baashyaam apartment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Most major banks and financial institutions provide home loans for Baashyaam properties with easy EMI options."
          }
        },
        {
          "@type": "Question",
          "name": "Are Baashyaam apartments RERA approved?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. All Baashyaam projects comply with RERA regulations, ensuring transparency and timely delivery."
          }
        },
        {
          "@type": "Question",
          "name": "How do I book a Baashyaam luxury apartment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can visit their official website, schedule a site visit, and book by paying a token advance."
          }
        },
        {
          "@type": "Question",
          "name": "What should I look for in the locality when choosing a luxury apartment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Good connectivity, proximity to schools/healthcare/shopping, safety, low risk of flooding, neighbourhood prestige, public transport access."
          }
        },
        {
          "@type": "Question",
          "name": "How are maintenance fees calculated, and how high are they for luxury apartments?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "They’re usually based on amenities offered, size of the complex, staffing and services included. The more amenities and service, the higher the fees. Always ask for past maintenance amounts & projections."
          }
        },
        {
          "@type": "Question",
          "name": "What about resale potential? Do luxury apartments retain value well?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Generally yes—especially if in premium locations, built by trustworthy developers, with good amenities, and in neighbourhoods that are growing. But luxury markets are niche; pricing and demand fluctuations should be considered."
          }
        },
        {
          "@type": "Question",
          "name": "Should I worry about ventilation, natural light, sea breeze (for coastal cities like Chennai)?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Definitely. In hot/humid climates, good ventilation, cross breezes, large windows, well-designed orientation can make a big difference in comfort & energy costs."
          }
        },
        {
          "@type": "Question",
          "name": "What tech/smart home features should I expect in a modern luxury apartment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Smart security, automated lighting, climate control, app-based building services (book amenities, track billing), maybe EV charging stations."
          }
        },
        {
          "@type": "Question",
          "name": "How do I avoid scams or pitfalls when buying luxury real estate?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Verify all legal documents, get inspections, check builder’s track record, compare pricing with similar projects, be careful of marketing hype."
          }
        }
      ]
    }
  ]
  
  
  // console.log('Layout SEO Debug:', {
  //   seoDataProvided: !!seoData,
  //   dynamicSEOData,
  //   currentSEOData,
  //   metaTitle: currentSEOData?.metaTitle
  // });
  
  // Generate meta tags using safe SEO data
  const openGraphTags = getOpenGraphTags(safeSEOData);
  const twitterCardTags = getTwitterCardTags(safeSEOData);
  // const structuredData = getStructuredData(safeSEOData);
  const metaTags = getAllMetaTags(safeSEOData);
  return (
    <>
      <Header />
      <Helmet key={safeSEOData.metaTitle}>
        <link rel="icon" href={favicon} />
        <title>{safeSEOData.metaTitle}</title>
        <meta name="description" content={safeSEOData.metaDescription} />
        <meta name="google-site-verification" content="rp2GnlhWd9PNW23P3COrVa_uB-eqrhVbOU1Ll10V2R4" />
        <link rel="canonical" href={safeSEOData.canonical} />
        {Object.entries(metaTags).map(([name, content]) => (
          <meta key={name} name={name} content={content} />
        ))}
        {/* Open Graph tags */}
        {Object.entries(openGraphTags).map(([property, content]) => (
          <meta key={property} property={property} content={content} />
        ))}
        
        {/* Twitter Card tags */}
        {Object.entries(twitterCardTags).map(([name, content]) => (
          <meta key={name} name={name} content={content} />
        ))}

        <script type="application/ld+json">
        {JSON.stringify(schemaJson)}
        </script>

        
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-DT3HD7V0M9"
        ></script>
      </Helmet>
      <main className="page-container">{children}</main>
      {from !== "Promenade" && from !== "Pinnacle" && from !== "Srinivasa" ? <Footer /> : ""}
    </>
  );
}

export default Layout;
